import React from "react";
import { message } from "antd";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MainPage from "../../MainPage";
import {
  apiCallback,
  statusChangeApiCallback,
} from "../../../ApiHandlers/Common";
import ListServiceConfig from "./ListServiceConfig";
import ServiceConfigForm from "./ServiceConfigForm";
import { EntityStatus, NavMenuItems } from "../../../Constants/Constants";
import { convertServiceConfigList } from "../../../Helpers/ConfigHelpers";
import { convertServiceSimpleList } from "../../../Helpers/ServiceHelpers";

class ServiceConfig extends React.Component {
  constructor(props) {
    super(props);
    this.header = [
      ...(props.parentBread || []),
      <>
        {NavMenuItems.configuration.icon()}
        <span>{NavMenuItems.configuration.service.label}</span>
      </>,
    ];
    this.state = {
      action: null,
      record: null,
      serviceData: [],
      serviceDataLoading: false,
      selectedService: null,
      serviceConfigData: [],
      serviceConfigDataLoading: false,
      deleteConfigLoading:false,
    };
  }

  componentDidMount() {
    this.updateServiceList();
  }

  updateServiceList = () => {
    const { history, serviceApi } = this.props;
    this.setState({ serviceDataLoading: true });
    const errorCallback = () => {
      this.setState({ serviceDataLoading: false });
      message.error("Error fetching Service list");
    };
    const successCallback = (data) => {
      const serviceData = convertServiceSimpleList(data);
      console.log("updateData data", serviceData);
      this.setState({ serviceData, serviceDataLoading: false });
    };
    try {
      serviceApi.getService(
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback();
    }
  };

  onServiceSelect = (id) => {
    this.setState({ selectedService: id, serviceConfigData: [] });
    id && this.updateServiceConfigList(id);
  };

  updateServiceConfigList = (id) => {
    const serviceId = id || this.state.selectedService;
    if (!serviceId) return;
    const { history, configManagementApi } = this.props;
    const errorCallback = () => {
      this.setState({ serviceConfigDataLoading: false });
      message.error("Error fetching Service Config list");
    };
    const successCallback = (data) => {
      const serviceConfigData = convertServiceConfigList(data);
      console.log("updateData data", serviceConfigData);
      this.setState({ serviceConfigData, serviceConfigDataLoading: false });
    };
    try {
      this.setState({ serviceConfigDataLoading: true });
      configManagementApi.getConfigByServiceId(
        serviceId,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback();
    }
  };

  onActionClick = (action, record) => () => {
    this.setState({ action, record });
  };

  onSubmit = ({ update = true, redirect = true } = {}) => {
    update && this.updateServiceConfigList();
    redirect && this.setState({ action: null, record: null });
  };

  onStatusChange = (record, status) => {
    try {
      console.log("onStatusChange", status, record);
      const callback = statusChangeApiCallback({
        props: this.props,
        recordName: record.name,
        errorRollback: () => this.changeStatus(record, !status),
      });
      this.props.configManagementApi.statusUpdateServiceConfig(
        record.serviceId,
        { status: status ? EntityStatus.ACTIVE : EntityStatus.INACTIVE },
        callback
      );
      this.changeStatus(record, status);
    } catch (error) {
      message.error(`Error changing status of ${record.name}`);
    }
  };

  deleteServiceConfig = (record) => {
    const { history, configManagementApi } = this.props;
    const errorCallback = (error) => {
      this.setState({deleteConfigDataLoading:false})
      console.log("Error deleting config", error);
      message.error("Unable to delete");
    };
    const successCallback = (data) => {
      this.setState({deleteConfigDataLoading:false})
      message.success("Config Deleted Successfully");
      this.updateServiceConfigList();
    };
    try {
      this.setState({deleteConfigDataLoading:true})
      const config = {
        config: record.config,
        serviceid: record.serviceId,
      };
      configManagementApi.removeServiceConfig(
        config,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };
  changeStatus = (record, status) => {
    try {
      const { configId } = record;
      const serviceConfigData = [...this.state.serviceConfigData];
      serviceConfigData.forEach((item) => {
        if (item.configId === configId) {
          item.status = status ? EntityStatus.ACTIVE : EntityStatus.INACTIVE;
        }
      });
      this.setState({ serviceConfigData });
    } catch (error) {
      message.error(`Error changing status of ${record.name}`);
    }
  };

  render() {
    const {
      action,
      record,
      serviceData,
      serviceDataLoading,
      selectedService,
      serviceConfigData,
      serviceConfigDataLoading,
      deleteConfigLoading,
    } = this.state;
    return (
      <MainPage>
        <div className="service-config-container">
          {!action ? (
            <ListServiceConfig
              serviceData={serviceData}
              serviceDataLoading={serviceDataLoading}
              selectedService={selectedService}
              serviceConfigData={serviceConfigData}
              serviceConfigDataLoading={serviceConfigDataLoading}
              deleteConfigLoading={deleteConfigLoading}
              onServiceSelect={this.onServiceSelect}
              onActionClick={this.onActionClick}
              onStatusChange={this.onStatusChange}
              deleteServiceConfig={this.deleteServiceConfig}
              parentBread={this.header}
            />
          ) : (
            <ServiceConfigForm
              action={action}
              record={record}
              serviceData={serviceData}
              serviceDataLoading={serviceDataLoading}
              onSubmit={this.onSubmit}
              onActionClick={this.onActionClick}
              parentBread={this.header}
            />
          )}
        </div>
      </MainPage>
    );
  }
}

ServiceConfig.propTypes = {
  serviceApi: PropTypes.object,
  configManagementApi: PropTypes.object,
  parentBread: PropTypes.array,
};

const mapStateToProps = (state) => ({
  serviceApi: state.apis.serviceApi,
  configManagementApi: state.apis.configManagementApi,
});
const connectedServiceConfig = connect(mapStateToProps)(ServiceConfig);
export default withRouter(connectedServiceConfig);
